import { useState } from "react";
import { visionURL } from "../../config/environment";
import JsonApiService from "../../services/jsonapiService";
import visionCallService from "../../services/visionCallService";

const activityCompletionsApiService = async () =>
  new JsonApiService("activity_completions", {
    baseUrl: `${visionURL}/learning_center/api`,
    credentials: "include"
  });

export const useActivityCompletions = () => {
  const [isCreating, setIsCreating] = useState(false);

  const createActivityCompletion = async newActivityCompletionData => {
    setIsCreating(true);
    const service = await activityCompletionsApiService();
    const response = await service.create(
      visionCallService.serializeRequestBody(
        newActivityCompletionData,
        "activityCompletion",
        ["courseContentable", "trainingObject"]
      )
    );
    setIsCreating(false);
    return response;
  };

  return {
    createActivityCompletion,
    isCreating
  };
};
